@if (headerService.showHeader() && isNotLoginPage()) {
  <header [class.desktop]="screenService.isDesktop()" [class.offline]="network.isOffline() && screenService.isMobile()">
    <div class="back-button">
      @if (headerService.showBackButton()) {
        <button type="button" (click)="headerService.goBack()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M17.8078 20C18.0072 20 18.2028 19.913 18.3218 19.7514C18.5112 19.4949 18.4346 19.1486 18.1507 18.9773L6.57804 12L18.1507 5.02269C18.4346 4.85141 18.5112 4.50543 18.3218 4.24867C18.1331 3.99223 17.7499 3.92266 17.466 4.09393L5.12301 11.5358C4.95156 11.6397 4.84807 11.8135 4.84807 12C4.84807 12.1866 4.95122 12.361 5.12301 12.4642L17.466 19.9061C17.5712 19.9697 17.6902 20 17.8078 20Z"
              fill="#14448F"
              stroke="#14448F"
              stroke-width="0.2"
              stroke-miterlimit="10"
            />
          </svg>
          @if (screenService.isDesktop()) {
            Back
          }
        </button>
      }
    </div>

    @if (screenService.isMobile()) {
      <div class="title">
        @if (headerService.title() !== null) {
          <h1 class="text">{{ headerService.title() }}</h1>
        } @else {
          <h1 class="logo" aria-label="Home">
            <img src="assets/svg/curro-blue.svg" alt="Curro logo" />
          </h1>
        }
      </div>
    } @else {
      <h1 class="logo" aria-label="Home">
        <img src="assets/svg/curro-blue.svg" alt="Curro logo" />
      </h1>
    }

    <div class="controls">
      <ng-container [ngTemplateOutlet]="headerService.actionsTemplate()" />
    </div>

    <app-header-debug-panel />
  </header>
}
